import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { MAX_PAGE_SIZE } from '@cbridge-utils/datagrid';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { fetchDictSymbolsRecursively } from '../_operators/fetchDictSymbolsRecursively';
import { DictSymbolAction } from '../dictSymbol.action';

type IDependencies = IClientApiDependencySegment;

export const loadSymbolsEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(DictSymbolAction.loadList.started),
  mergeMap((params) => {
    const { search } = params;

    return fetchDictSymbolsRecursively(
      {
        limit: MAX_PAGE_SIZE,
        skip: 0,
        search,
      },
      dependencies,
    ).pipe(
      mergeMap((symbols) => {
        return [
          DictSymbolAction.loadList.done({ params, result: symbols }),
        ];
      }),
      catchApiError((error) => {
        return [
          DictSymbolAction.loadList.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
